import { Button, FormDialog } from '@/ui'
import { PaymentMethodData } from '@jobilla/nexus-sdk'
import { FormEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NicknameField } from './NicknameField'

export interface EditNicknameDialogProps {
	paymentMethod: PaymentMethodData | null
	onClose: () => void
	onSave: (paymentMethod: PaymentMethodData, nickname: string | null) => void
	isSaving: boolean
}

export function EditNicknameDialog({ paymentMethod, onClose, onSave, isSaving }: EditNicknameDialogProps) {
	const { t } = useTranslation('common')
	const [nickname, setNickname] = useState('')

	useEffect(() => {
		if (paymentMethod) {
			setNickname(paymentMethod.nickname ?? '')
		}
	}, [paymentMethod])

	const handleSubmit = (e: FormEvent) => {
		e.preventDefault()
		if (!paymentMethod) {
			return
		}
		const trimmed = nickname.trim()
		onSave(paymentMethod, trimmed === '' ? null : trimmed)
	}

	const open = paymentMethod !== null
	const handleClose = () => {
		if (isSaving) {
			return
		}
		onClose()
	}

	return (
		<FormDialog
			open={open}
			onClose={handleClose}
			title={t('settings.paymentMethods.editNickname.title')}
			maxWidth="md"
		>
			<form onSubmit={handleSubmit} className="space-y-4">
				<NicknameField value={nickname} onChange={setNickname} disabled={isSaving} />

				<div className="flex justify-end gap-2 pt-2 border-t border-grey-100 -mx-6 px-6 pt-4 mt-2">
					<Button
						type="subtle"
						size="short"
						onClick={handleClose}
						disabled={isSaving}
					>
						{t('settings.paymentMethods.editNickname.cancel')}
					</Button>
					<Button
						type="committal"
						size="short"
						onClick={handleSubmit}
						disabled={isSaving}
						isLoading={isSaving}
					>
						{t('settings.paymentMethods.editNickname.save')}
					</Button>
				</div>
			</form>
		</FormDialog>
	)
}
